import BaseDrawer from '@c/drawers/BaseDrawer';
import type { ChatDocument } from '@models/chat';
import { markAsRead } from '@util/firestore/messages';
import { useAuth } from 'context/AuthContext';
import { useChat } from 'context/ChatContext';
import ChatWindow from './chat/ChatWindow';
import ConversationList from './dashboard/ConversationList';

interface ChatProps {
  chat?: ChatDocument;
  setSelectedChat: (chat?: ChatDocument) => void;
}

const Chat = ({ chat, setSelectedChat }: ChatProps) => {
  const { user } = useAuth();
  const { chatOpen, setChatOpen } = useChat();

  const onChatSelected = (chat: ChatDocument) => {
    setSelectedChat(chat);
    if (chat.id && user?.uid && chatOpen) {
      markAsRead(chat, user.uid);
    }
  };

  return (
    <BaseDrawer
      show={chatOpen}
      position="right"
      dismiss={() => setChatOpen(false)}
    >
      <div className="flex h-full w-[60rem] flex-col">
        {!chat ? (
          <div className="flex h-full w-full">
            <div className="h-full grow overflow-y-auto">
              <ConversationList
                onChatSelected={onChatSelected}
                isSidebar={true}
                onCloseSidebar={() => {
                  setChatOpen(false);
                }}
              />
            </div>
          </div>
        ) : (
          <>
            <div className="h-full w-full grow overflow-y-auto">
              <ChatWindow
                chatId={chat.id}
                key={chat.id}
                isSidebar
                onGoBack={() => {
                  setSelectedChat(undefined);
                }}
              />
            </div>
          </>
        )}
      </div>
    </BaseDrawer>
  );
};

export default Chat;
